import { EntityType } from "constants/entities.enum";
import { createEntityState } from "entities/charts/factory";
import { createMergeWithDefaults } from "entities/utils";
import { EvaChartFeatures } from "types";

import { BASE_RATE_FEATURES } from "./baseRateFeatures";

const CUM_TIME_FEATURES: Partial<EvaChartFeatures> = {
  ...BASE_RATE_FEATURES,
  forecast: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true,
    active: false
  }),
  // Cum Time does not support log axes — suppress from UI
  logAxis: createEntityState(EntityType.LogAxisFeature, {
    show: false
  }),
  p10: createEntityState(EntityType.P10Feature, {
    show: true
  }),
  p50: createEntityState(EntityType.P50Feature, {
    show: true
  }),
  p90: createEntityState(EntityType.P90Feature, {
    show: true
  }),
  average: createEntityState(EntityType.AverageFeature, {
    show: true
  })
};

export const cumTimeFeatures = createMergeWithDefaults(CUM_TIME_FEATURES);
